import { useMemo } from "react";

import type { AssetSource, ImageAsset } from "../assetTypes.ts";
import { extractImageDimensions } from "../metadataExtractors/index.ts";
import { useGetCachedAssetBlob } from "../query/index.ts";

type AdditionalMetadata = Record<string, unknown>;

// measure the image to create the full asset object given a source
export const useConstructImageAsset = () => {
  const getCachedAssetBlob = useGetCachedAssetBlob();

  return useMemo(
    () =>
      async (source: AssetSource, metadata: AdditionalMetadata = {}): Promise<ImageAsset | undefined> => {
        // this method instead of createImageBitmap means we are pre-caching as well for display
        let blob: Blob | null = null;

        if ("assetId" in source) {
          blob = await getCachedAssetBlob(source.assetId);
        } else if (source.url) {
          try {
            const res = await fetch(source.url);
            if (res.ok) {
              blob = await res.blob();
            }
          } catch {
            // we can't control external url servers. and often cors blocked
            // currently just ignoring in case <img src> still works as dimensions not essential
          }
        }
        const { width, height } = blob ? await extractImageDimensions(blob) : {};
        return { source, width, height, ...metadata };
      },
    [getCachedAssetBlob],
  );
};
